import { render } from "./sidebar-items.vue?vue&type=template&id=455cee65"
import script from "./sidebar-items.vue?vue&type=script&lang=js"
export * from "./sidebar-items.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__